import { Component, OnInit, Input, Renderer2, ElementRef } from '@angular/core';
import { encapsulation } from '../../encapsulation';
import { Splitter } from '../../../models';

@Component({
    selector: 'ubx-track',
    templateUrl: './track.component.html',
    host: { class: 'ubx-track' },
    encapsulation
})
export class UBXTrackComponent implements OnInit {
    @Input() colSpan: string | number;
    @Input() rowSpan: string | number;

    @Input() js: string;
    @Input() as: string;

    split: Splitter = new Splitter();

    constructor(
        private renderer: Renderer2,
        public el: ElementRef,
    ) { }

    ngOnInit() {
        this.setAlign(this.js, 'js');
        this.setAlign(this.as, 'as');
    }

    setTrack(direction: string, span: string | number, media: string) {
        this.appendClass(`g-${direction}s:${span + media}`);
    }
    setSpan(direction: string, span: string | number) {
        this.split.splitter((span), split => {
            this.appendClass(`g-${direction}s:${split.value + split.media}`);
        });
    }
    private setAlign(align: string, axis: string) {
        this.split.splitter((align), split => {
            this.appendClass(`g-${axis}:${split.value + split.media}`);
        });
    }

    private appendClass(name: string | number) {
        this.renderer.addClass(this.el.nativeElement, String(name));
    }
}
